import { formatTopicSchedule, SCHEDULE_TIMEZONE } from './schedule';
export const canManageActivities = (course?: Model.Class) =>
  course?.can_edit_curriculum === true ||
  course?.can_manage_activities === true;
export const canEditSchedule = (course?: Model.Class) =>
  course?.can_edit_curriculum === true ||
  course?.can_edit_topic_schedule === true;
export const hasStaffCourseAccess = (course?: Model.Class) =>
  canManageActivities(course) || canEditSchedule(course);
export const hideProgrammeBios = (course?: Model.Class, email?: string) =>
  course?.type === 'CISL' &&
  email?.trim().toLowerCase().split('@').length === 2 &&
  email.trim().toLowerCase().split('@')[1] === 'cisl.cam.ac.uk';
export const activityTypes = ['QNA', 'FORUM', 'POLL', 'RATING'];
export const isActivity = (type?: string) => activityTypes.includes(type || '');
export const topicTime = (startAt?: string, endAt?: string | null) =>
  formatTopicSchedule({ start_at: startAt, end_at: endAt });
export const localTimezone = () => SCHEDULE_TIMEZONE;
